import { SVGProps } from 'react';

const SvgTrash = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" {...props}>
        <path d="M4.75 0v.778H.86v1.555h.779v10.111A1.556 1.556 0 0 0 3.194 14h7.778a1.556 1.556 0 0 0 1.556-1.556V2.334h.777V.777H9.416V0H4.75ZM3.194 2.333h7.778v10.111H3.194V2.334ZM4.75 3.89v7h1.555v-7H4.75Zm3.11 0v7h1.556v-7H7.861Z" />
    </svg>
);
export default SvgTrash;
